// Authed backend for the MEMBERS' Golf Game Central surface (/gg). Same
// completetourneylive project as ggBackend.js, but a SEPARATE Firebase app that
// carries Auth — so a signed-in member's identity never bleeds into the
// staff/admin GGC (which uses ggBackend with no auth, the access-code path).
// Member game data still lands in the SAME /ggGames + /memberGames the companion
// app uses — this is only about who's authenticated for member writes.
import { initializeApp, getApps } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'

const cfg = {
  apiKey: 'AIzaSyBvw9vL3ibLZeKZN3e18Cr2oCgxCpEZ_p8',
  authDomain: 'completetourneylive.firebaseapp.com',
  projectId: 'completetourneylive',
  storageBucket: 'completetourneylive.firebasestorage.app',
  messagingSenderId: '323912066278',
  appId: '1:323912066278:web:50d1ff498a4eec1c088727',
  databaseURL: 'https://completetourneylive-default-rtdb.firebaseio.com',
}

const NAME = 'memberBackend'
const app = getApps().find((a) => a.name === NAME) ?? initializeApp(cfg, NAME)

export const memberDb = getDatabase(app)
export const memberAuth = getAuth(app)              // browser-local persistence by default
export const memberFunctions = getFunctions(app)    // us-central1 — matches memberAuth fn
